export interface User {
    display: string;
    username: string;
    token: string;
    subscriberID: number;
    subscriberNameFirst: string;
    subscriberNameLast: string;
    subscriberEmail: string;
    subscriberPhone: string;
    address: string;
    address2: string;
    city: string;
    state: string;
    zipCode: string;
    createdDate: Date;
    homeShippingSameInd: string;
    homeBillingSameInd: string;
    shippingFirstName: string;
    shippingLastName: string;
    shippingAddress: string;
    shippingAddress2: string;
    shippingCity: string;
    shippingState: string;
    shippingZipcode: string;
    billingAddress: string;
    billingAddress2: string;
    billingCity: string;
    billingState: string;
    billingZipcode: string;
}

export interface LoginFormValues {
    subscriberEmail: string;
    securityOverrideKeyword: string;
}

export interface UserFormValues {
    subscriberEmail: string;
    securityOverrideKeyword: string;
    subscriberNameFirst: string;
    subscriberNameLast: string;
    address: string;
    address2: string;
    city: string;
    state: string;
    zipCode: string;
    subscriberPhone: string;
}

export interface UserForgotPasswordValues {
    subscriberEmail: string;
    error: string;
}

export class ForgotPasswordFormValues implements UserForgotPasswordValues {
    subscriberEmail: string = '';
    error: string = '';
}

export class UserFormValues implements UserFormValues {
    subscriberID: number = 0;
    subscriberEmail: string = '';
    securityOverrideKeyword: string = '';
    securityOverrideKeyword2: string = '';
    subscriberNameFirst: string = '';
    subscriberNameLast: string = '';
    address: string = '';
    address2: string = '';
    city: string = '';
    state: string = '';
    zipCode: string = '';
    subscriberPhone: string = '';
    error: string = '';
    
    constructor(init?: Partial<UserFormValues>) {
        Object.assign(this, init);
    }
}

export interface UserShippingAddressFormValues {
    shippingFirstName: string;
    shippingLastName: string;
    shippingAddress: string;
    shippingAddress2: string;
    shippingCity: string;
    shippingState: string;
    shippingZipcode: string;
}
export class UserShippingAddressFormValues implements UserShippingAddressFormValues {
    shippingFirstName: string = '';
    shippingLastName: string = '';
    shippingAddress: string = '';
    shippingAddress2: string = '';
    shippingCity: string = '';
    shippingState: string = '';
    shippingZipcode: string = '';
    error: string = '';
    
    constructor(init?: Partial<UserShippingAddressFormValues>) {
        Object.assign(this, init);
    }
}
export interface UserBillingAddressFormValues {
    billingAddress: string;
    billingAddress2: string;
    billingCity: string;
    billingState: string;
    billingZipcode: string;
}
export class UserBillingAddressFormValues implements UserBillingAddressFormValues {
    billingAddress: string = '';
    billingAddress2: string = '';
    billingCity: string = '';
    billingState: string = '';
    billingZipcode: string = '';
    error: string = '';
    
    constructor(init?: Partial<UserBillingAddressFormValues>) {
        Object.assign(this, init);
    }
}

export class ReportFormValues {
    email: string = '';
    message: string = '';
    reason: string = '';
    agree: boolean = false;
}